import map from 'lodash/map';

export const GOOGLE_MAP_SETTINGS = {
	staticMapURL : 'https://maps.googleapis.com/maps/api/staticmap',
	geocoderURL  : 'https://maps.googleapis.com/maps/api/geocode/json',
	key          : 'AIzaSyCSdMP2Hcf0kWrikqBW-vVcmKhqLxvoAGw',
	styles       : [
		{
			featureType : 'administrative.country',
			elementType : 'geometry.stroke',
			stylers     : [
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'poi.attraction',
			elementType : 'geometry',
			stylers     : [
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'poi.attraction',
			elementType : 'geometry.fill',
			stylers     : [
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'poi.attraction',
			elementType : 'geometry.stroke',
			stylers     : [
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'poi.attraction',
			elementType : 'labels.text.fill',
			stylers     : [
				{
					hue : '#ff0000',
				},
			],
		},
		{
			featureType : 'poi.attraction',
			elementType : 'labels.text.stroke',
			stylers     : [
				{
					hue : '#ff0000',
				},
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'poi.attraction',
			elementType : 'labels.icon',
			stylers     : [
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'poi.business',
			elementType : 'labels.text',
			stylers     : [
				{
					hue : '#ff0000',
				},
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'road.local',
			elementType : 'geometry.fill',
			stylers     : [
				{
					visibility : 'simplified',
				},
			],
		},
		{
			featureType : 'road.local',
			elementType : 'labels.text',
			stylers     : [
				{
					hue : '#ff0000',
				},
			],
		},
		{
			featureType : 'road.local',
			elementType : 'labels.text.fill',
			stylers     : [
				{
					hue : '#ff0000',
				},
			],
		},
	], // https://snazzymaps.com/
	defaultCenter : {
		lat : 41.8857156,
		lng : -87.6482378,
	},
};

export const GOOGLE_MAP_OPTIONS = {
	styles                 : GOOGLE_MAP_SETTINGS.styles,
	mapTypeControl         : true,
	scrollwheel            : false,
	disableDoubleClickZoom : true,
	fullscreenControl      : false,
};

export const CARD_ICONS = {
	default            : '/images/cardIcons/default.png',
	'master-card'      : '/images/cardIcons/mastercard.png',
	visa               : '/images/cardIcons/visa.png',
	'american-express' : '/images/cardIcons/amex.png',
	discover           : '/images/cardIcons/discover.png',
	'diners-club'      : '/images/cardIcons/diners.png',
	jcb                : '/images/cardIcons/jcb.png',
};

export const MASK_VALUE = {
	phoneMask      : ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	dateExpiryMask : [/[0-9]/, /\d/, '/', /\d/, /\d/],
	ssnMask        : [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	ssnLast4Mask   : [/\d/, /\d/, /\d/, /\d/],
	dobMask        : [/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	creditCardMask : [/[0-9]/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	cvcMask        : [/[0-9]/, /\d/, /\d/],
	zipMask        : [/\d/, /\d/, /\d/, /\d/, /\d/],

};

export const INVOICE_STATUSES = {
	CREATED               : 1,
	PENDING_REVIEW        : 2,
	AMENDED               : 3,
	PENDING_PAYMENT       : 4,
	PENDING_PROCESSING    : 5,
	PAID                  : 6,
	PAYMENT_REJECTED      : 7,
	DISPUTED              : 8,
	DEPOSITED             : 9,
	DEPOSIT_FAILED        : 10,
	CANCELLED             : 11,
	PENDING_CLIENT_REVIEW : 12,
};

export const INOVICE_STATUSES_SELECT = [
	{
		value : INVOICE_STATUSES.CREATED,
		label : 'Created',
	},
	{
		value : INVOICE_STATUSES.PENDING_REVIEW,
		label : 'Pending Review',
	},
	{
		value : INVOICE_STATUSES.AMENDED,
		label : 'Amended',
	},
	{
		value : INVOICE_STATUSES.PENDING_PAYMENT,
		label : 'Pending Payment',
	},
	{
		value : INVOICE_STATUSES.PENDING_PROCESSING,
		label : 'Pending Processing',
	},
	{
		value : INVOICE_STATUSES.PAID,
		label : 'Paid',
	},
	{
		value : INVOICE_STATUSES.PAYMENT_REJECTED,
		label : 'Payment Rejected',
	},
	{
		value : INVOICE_STATUSES.DISPUTED,
		label : 'Disputed',
	},
	{
		value : INVOICE_STATUSES.DEPOSITED,
		label : 'Deposited',
	},
	{
		value : INVOICE_STATUSES.DEPOSIT_FAILED,
		label : 'Deposit Failed',
	},
	{
		value : INVOICE_STATUSES.CANCELLED,
		label : 'Cancelled',
	},
];

export const VIEW_INVOICE_STATUS = {
	submission : {
		value       : 1,
		viewType    : 'submission',
		countKey    : 'submission',
		displayName : 'Pending Submission',
		description : 'List of invoices which are yet to be submitted by the officers',
		button      : 'Submit Selected',
		bulkButton  : '',
	},
	balance : {
		value            : -1,
		viewType         : 'balance',
		countKey         : 'balance',
		displayName      : 'Balance',
		description      : 'Account Balance',
		button           : '',
		bulkButton       : '',
		externalEndpoint : true,
	},
	review : {
		value       : 3,
		viewType    : 'review',
		countKey    : 'review',
		displayName : 'Pending Review',
		description : 'List of invoices which are yet to be approved/disputed by the clients',
		button      : 'Approve Selected',
		bulkButton  : '',
	},
	payment : {
		value       : 4,
		viewType    : 'payment',
		countKey    : 'payment',
		displayName : 'Awaiting Payment',
		description : 'List of invoices which are yet to be paid by the clients',
		button      : 'Pay Selected',
		bulkButton  : 'Pay All',
	},
	dispute : {
		value       : 2,
		viewType    : 'dispute',
		countKey    : 'dispute',
		displayName : 'Disputes',
		description : 'List of invoices which are disputed by the clients',
		button      : '',
		bulkButton  : '',
	},
	paid : {
		value       : 6,
		viewType    : 'paid',
		countKey    : 'paid',
		displayName : 'Recently Paid',
		description : '',
		button      : '',
		bulkButton  : '',
	},
};

export const VIEW_INVOICE_STATUS_MAP = map(VIEW_INVOICE_STATUS);

export const OFFICER_STATUSES = {
	none : {
		type        : 0,
		description : 'None',
		color       : 'default',
	},
	noClockIn : {
		type        : 1,
		description : 'No Clock In',
		color       : 'warning-alt',
	},
	clockedIn : {
		type        : 2,
		description : 'Clocked In',
		color       : 'success',
	},
	earlyClockOut : {
		type        : 3,
		description : 'Early Clock Out',
		color       : 'warning',
	},
	earlyClockOutOffsite : {
		type        : 4,
		description : 'Early Clock Out Offsite',
		color       : 'danger',
	},
	clockedOutOffsite : {
		type        : 5,
		description : 'Clocked Out Offsite',
		color       : 'danger',
	},
	clockedOut : {
		type        : 6,
		description : 'Clocked Out',
		color       : 'success',
	},
	lateClockInOnsite : {
		type        : 7,
		description : 'Late Clock In Onsite',
		color       : 'warning',
	},
	lateClockInOffsite : {
		type        : 8,
		description : 'Late Clock In Offsite',
		color       : 'danger',
	},
	lateClockIn : {
		type        : 9,
		description : 'Late Clock In',
		color       : 'warning',
	},
	onsite : {
		type        : 10,
		description : 'Onsite',
		color       : 'success',
	},
	offsite : {
		type        : 11,
		description : 'Offsite',
		color       : 'danger',
	},
	seekingReplacement : {
		type        : 12,
		description : 'Seeking Replacement',
		color       : 'danger',
	},
};

export const OFFICER_STATUSES_MAP = map(OFFICER_STATUSES);

export const ORGANIZATION_TYPE = {
	SECURITY_AGENCY            : 10,
	CLIENT                     : 20,
	LAW_ENFORCEMENT_DEPARTMENT : 30,
	COORDINATOR                : 40,
};

export const USER_TYPE = {
	SUPER_ADMIN     : 1,
	CLIENT          : 20,
	AGENCY_ADMIN    : 30,
	LAW_ENFORCEMENT : 40,
	COORDINATOR     : 50,
};

export const JOB_TYPES = {
	needApproval : {
		type        : 3,
		name        : 'needApproval',
		countKey    : 'NeedApproval',
		displayName : 'Need Approval',
		description : 'List of pending approval Estimate Invoices',
	},
	active : {
		type        : 1,
		name        : 'active',
		countKey    : 'Active',
		displayName : 'Active',
		description : 'List of active jobs',
	},
	upcoming : {
		type        : 2,
		name        : 'upcoming',
		countKey    : 'Upcoming',
		displayName : 'Upcoming',
		description : 'List of upcoming jobs',
	},
	unstaffed : {
		type        : 2,
		name        : 'unstaffed',
		countKey    : 'Unstaffed',
		displayName : 'Unstaffed',
		description : 'List of jobs which are not assigned to any officers',
	},
	completed : {
		type        : 3,
		name        : 'completed',
		countKey    : 'Completed',
		displayName : 'Completed',
		description : 'List of completed jobs',
	},
};

export const JOB_TYPES_MAP = map(JOB_TYPES, (object, viewType) => ({
	...object,
	viewType,
}));

export const LOCATION_APPROVAL_TYPES = {
	pending : {
		type        : 30,
		countKey    : 'Pending',
		displayName : 'Pending Approval',
		description : 'List of locations with pending approval review',
		color       : 'pending',
		icon        : 'rkf rkf-clock',
	},
	approved : {
		type        : 10,
		countKey    : 'Approved',
		displayName : 'Approved',
		description : 'List of approved locations',
		color       : 'success',
		icon        : 'rkf rkf-check-mark',
	},
	denied : {
		type        : 20,
		countKey    : 'Denied',
		displayName : 'Denied',
		description : 'List of denied locations',
		color       : 'danger',
		icon        : 'rkf rkf-cross-circle',
	},
};

export const LOCATION_APPROVAL_TYPES_MAP = map(LOCATION_APPROVAL_TYPES, (object, viewType) => ({
	...object,
	viewType,
}));

export const JOB_APPROVAL_TYPES = {
	pending : {
		type        : 30,
		countKey    : 'Pending',
		displayName : 'Pending Approval',
		description : 'List of jobs with pending approval applications',
		color       : 'pending',
		icon        : 'rkf rkf-clock',
	},
	approved : {
		type        : 10,
		countKey    : 'Approved',
		displayName : 'Approved',
		description : 'List of approved job applications',
		color       : 'success',
		icon        : 'rkf rkf-check-mark',
	},
	denied : {
		type        : 20,
		countKey    : 'Denied',
		displayName : 'Unapproved',
		description : 'List of unapproved job applications',
		color       : 'danger',
		icon        : 'rkf rkf-cross-circle',
	},
};

export const TAX_EXEMPTION_TYPES = {
	pending : {
		status      : 'pending',
		countKey    : 'Pending',
		displayName : 'Pending Approval',
		description : 'List of pending approval Tax Exemption Requests',
		color       : 'warning',
		icon        : 'rkf rkf-clock',
	},
	approved : {
		status      : 'approved',
		countKey    : 'Approved',
		displayName : 'Approved',
		description : 'List of approved Tax Exemption Requests',
		color       : 'success',
		icon        : 'rkf rkf-check-mark',
	},
	denied : {
		status      : 'denied',
		countKey    : 'Denied',
		displayName : 'Denied',
		description : 'List of denied Tax Exemption Requests',
		color       : 'danger',
		icon        : 'rkf rkf-cross-circle',
	},
};

export const JOB_APPROVAL_TYPES_MAP = map(JOB_APPROVAL_TYPES, (object, viewType) => ({
	...object,
	viewType,
}));

export const TAX_EXEMPTION_TYPES_MAP = map(TAX_EXEMPTION_TYPES, (object, viewType) => ({
	...object,
	viewType,
}));

export const RECURRENCE_FREQUENCIES = {
	DAILY    : { value : 1, label : 'Daily' },
	WEEKDAYS : { value : 2, label : 'Weekdays (Mon - Fri)' },
	WEEKENDS : { value : 3, label : 'Weekends (Sat - Sun)' },
	WEEKLY   : { value : 4, label : 'Weekly' },
};

export const FORM_JOB_TYPES = {
	GENERAL_SECURITY       : { value : 1 },
	TRAFFIC_CONTROL        : { value : 2 },
	HIGHWAY_TRAFFIC_SAFETY : { value : 3 },
	TERMINATION            : { value : 4 },
	ROVING_PATROL          : { value : 5 },
	EVENT                  : { value : 6 },
};

export const JURISDICTION_EXPIRES_OPTIONS = [
	{ value : 0, label : 'Never' },
	{ value : 1, label : '1 day' },
	{ value : 2, label : '2 days' },
	{ value : 3, label : '3 days' },
	{ value : 4, label : '4 days' },
	{ value : 5, label : '5 days' },
	{ value : 6, label : '6 days' },
	{ value : 7, label : '1 week' },
	{ value : 14, label : '2 weeks' },
];

export const DAYS_OF_WEEK = [
	{
		value : 2, label : 'Monday', shortName : 'mon', frequencyType : 'weekday',
	},
	{
		value : 3, label : 'Tuesday', shortName : 'tue', frequencyType : 'weekday',
	},
	{
		value : 4, label : 'Wednesday', shortName : 'wed', frequencyType : 'weekday',
	},
	{
		value : 5, label : 'Thursday', shortName : 'thu', frequencyType : 'weekday',
	},
	{
		value : 6, label : 'Friday', shortName : 'fri', frequencyType : 'weekday',
	},
	{
		value : 7, label : 'Saturday', shortName : 'sat', frequencyType : 'weekend',
	},
	{
		value : 1, label : 'Sunday', shortName : 'sun', frequencyType : 'weekend',
	},
];

export const JOB_POSTED_TYPES = {
	ALL                    : 0,
	ALL_GROUPS             : 1,
	GROUPS                 : 2,
	ALL_MINUTES_CONSTRAINT : 3,
	ALL_WEEKDAY_CONSTRAINT : 4,
};

export const OFFICER_STATUS_TO_FETCH_DATA = [2, 6];

export const UN_ASSIGNMENT_REASONS = [
	{
		value : 1,
		label : 'Called Off',
	},
	{
		value : 2,
		label : 'Client Cancel',
	},
	{
		value : 3,
		label : 'Officer Swap',
	},
	{
		value : 4,
		label : 'No-Show',
	},
	{
		value : 5,
		label : 'Reassign',
	},
	{
		value : 6,
		label : 'Another Reason',
	},
];

export const BULK_PAYMENT_JOB_TIMER = 10000;

export const BULK_PAYMENT_STATUSES = {
	CREATED       : 1,
	ON_EXECUTION  : 2,
	SUCCEEDED     : 3,
	FAILED        : 4,
	CHARGE_FAILED : 5,
};

export const AUTO_APPROVAL_TYPES = {
	MANUAL                  : 1,
	FIRST_COME_FIRST_SERVED : 2,
	BY_HOURS                : 3,
	BY_JOBS                 : 4,
	SENIORITY_DESCENDING    : 5,
	SENIORITY_ASCENDING     : 6,
	RANDOM                  : 7,
};

export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD';

export const OFFICER_VETTED_STATUS = [
	{ value : 0, label : 'New', color : 'default' },
	{ value : 1, label : 'Pending', color : 'warning' },
	{ value : 2, label : 'Verified', color : 'success' },
	{ value : 3, label : 'Denied', color : 'danger' },
	{ value : 4, label : 'Hold', color : 'warning' },
	{ value : 5, label : 'Expired', color : 'danger' },
	{ value : 6, label : 'Pending Reverification', color : 'warning' },
];

export const LOCATION_DENIAL_UNASSIGN_ACTIONS = {
	DEFAULT : 0,
	DELETE  : 1,
	KEEP    : 2,
};

export const PAYMENT_METHOD_TYPES = [
	{ value : 'bankAccount', label : 'ACH Bank Transfer' },
	{ value : 'creditCard', label : 'Credit Card' },
];

export const BANK_ACCOUNT_TYPES = {
	INDIVIDUAL : { value : 1, label : 'Individual' },
	COMPANY    : { value : 2, label : 'Company' },
};

export const BANK_ACCOUNT_STATUSES = {
	DEFAULT        : { value : null, label : 'Unknown' },
	VERIFIED       : { value : 1, label : 'Verified' },
	NEW            : { value : 2, label : 'New' },
	VALIDATED      : { value : 3, label : 'Validated' },
	VERIFIED_ERROR : { value : 4, label : 'Verified Error' },
	ERROR          : { value : 5, label : 'Error' },
};

export const ORGANIZATION_SETTINGS_MENU = [
	{
		id    : 'information',
		title : 'Agency Information',
		icon  : 'rkf rkf-police-office',
		roles : [
			USER_TYPE.SUPER_ADMIN,
			USER_TYPE.CLIENT,
			USER_TYPE.AGENCY_ADMIN,
			USER_TYPE.LAW_ENFORCEMENT,
		],
	},
	{
		id    : 'assignment',
		title : 'Officer Approval & Assignment',
		icon  : 'rkf rkf-profile-cop',
		roles : [
			USER_TYPE.SUPER_ADMIN,
			USER_TYPE.CLIENT,
			USER_TYPE.AGENCY_ADMIN,
			USER_TYPE.LAW_ENFORCEMENT,
			USER_TYPE.COORDINATOR,
		],
	},
	{
		id    : 'calloff',
		title : 'Officer Call Off',
		icon  : 'rkf rkf-exit',
		roles : [
			USER_TYPE.SUPER_ADMIN,
			USER_TYPE.CLIENT,
			USER_TYPE.AGENCY_ADMIN,
			USER_TYPE.LAW_ENFORCEMENT,
			USER_TYPE.COORDINATOR,
		],
	},
	{
		id    : 'insurancesettings',
		title : 'Officer Insurance',
		icon  : 'rkf rkf-umbrella-cop',
		roles : [USER_TYPE.LAW_ENFORCEMENT],
	},
	{
		id    : 'locationapprovals',
		title : 'Location Approvals',
		icon  : 'rkf rkf-map',
		roles : [USER_TYPE.LAW_ENFORCEMENT],
	},
	{
		id    : 'hourlyrestrictions',
		title : 'Hourly Restrictions',
		icon  : 'rkf rkf-clock',
		roles : [USER_TYPE.LAW_ENFORCEMENT],
	},
	{
		id    : 'jobrestrictions',
		title : 'Job Restrictions',
		icon  : 'rkf rkf-locked',
		roles : [USER_TYPE.LAW_ENFORCEMENT],
	},
	{
		id    : 'coordinatorjobs',
		title : 'Coordinator Jobs',
		icon  : 'rkf rkf-search-job',
		roles : [USER_TYPE.LAW_ENFORCEMENT],
	},
	{
		id    : 'supervisorapprovals',
		title : 'Supervisor Approvals',
		icon  : 'rkf rkf-person-check-mark-circle',
		roles : [USER_TYPE.LAW_ENFORCEMENT],
	},
	{
		id    : 'officerfulfillment',
		title : 'Officer Fulfillment',
		icon  : 'rkf rkf-clipboard',
		roles : [
			USER_TYPE.CLIENT,
			USER_TYPE.AGENCY_ADMIN,
			USER_TYPE.LAW_ENFORCEMENT,
			USER_TYPE.COORDINATOR,
		],
	},
	{
		id    : 'paymentsettings',
		title : 'Payment & invoicing',
		icon  : 'rkf rkf-dollar-circle',
		roles : [USER_TYPE.LAW_ENFORCEMENT],
	},
];

export const STATIC_URLS = {
	supportUrl : 'https://support.rollkall.com/hc/en-us',
	rootUrl    : 'https://www.rollkall.com',
};

export const JURISDICTION_FEE_TYPES = [
	{ value : 1, label : '/ Job' },
	{ value : 2, label : '/ Hour' },
];

export const JOBS_ALERTS_LEGEND = {
	N : 'No Clock-In',
	E : 'Early Clock-Out',
	L : 'Late Clock-In',
	O : 'OffSite',
};

const OFFICERS_ACTIONGRID = [
	{
		vettedStatus : '',
		countKey     : 'All',
		displayName  : 'Officers',
		description  : 'All the officers',
	},
	{
		vettedStatus : '0',
		countKey     : 'New',
		displayName  : 'New',
		description  : 'List of new officers',
	},
	{
		vettedStatus : '1',
		countKey     : 'PendingApproval',
		displayName  : 'Pending',
		description  : 'List of pending approval officers',
	},
	{
		vettedStatus : '6',
		countKey     : 'PendingReverification',
		displayName  : 'Pending Re-Verification',
		description  : 'List of officers with pending re-verification',
	},
];

const INVOICE_FEE_TYPES = {
	TIMECARD             : { value : 1, label : 'Time Card' },
	MISCELLANEOUS        : { value : 2, label : 'Officer Miscellaneous Item' },
	ORGANIZATION         : { value : 3, label : 'Organization Fee' },
	INSURANCE            : { value : 4, label : 'Insurance Fee' },
	JURISDICTION         : { value : 5, label : 'Jurisdiction Fee' },
	JURISDICTION_VEHICLE : { value : 6, label : 'Jurisdiction Vehicle Fee' },
};

const RECURRENCE_CONFLICT_TYPES = {
	CANNOT_ASSIGN_FUTURE_JOBS         : { value : 1, label : 'Cannot Assign Future Jobs' },
	FUTURE_JOB_COLLISIONS             : { value : 2, label : 'Future Job Collisions' },
	CURRENT_JOB_COLLISIONS            : { value : 3, label : 'Current Job Collisions' },
	CURRENT_AND_FUTURE_JOB_COLLISIONS : { value : 4, label : 'Current And Future Job Collisions' },
};

// Active Directory user cancellation code
export const B2C_USER_CANCELLED = 'AADB2C90091';

export const ROUTES = {
	ADCallback         : '/ad/callback',
	resetPassword      : '/ad/resetPassword',
	account            : '/account',
	root               : '/',
	login              : '/login',
	signupClient       : '/signup',
	signupClientAD     : '/signup/ad/client',
	signupConfirmation : '/signup/confirmation',
};

export const ADOPERATIONS = {
	changePassword : 'changePassword',
	resetPassword  : 'resetPassword',
	login          : 'login',
	signup         : 'signup',
};

export default {
	GOOGLE_MAP_SETTINGS,
	GOOGLE_MAP_OPTIONS,
	CARD_ICONS,
	MASK_VALUE,
	OFFICER_STATUSES,
	OFFICER_STATUSES_MAP,
	INVOICE_STATUSES,
	INOVICE_STATUSES_SELECT,
	USER_TYPE,
	JOB_TYPES,
	JOB_TYPES_MAP,
	LOCATION_APPROVAL_TYPES,
	LOCATION_APPROVAL_TYPES_MAP,
	JOB_APPROVAL_TYPES,
	JOB_APPROVAL_TYPES_MAP,
	TAX_EXEMPTION_TYPES,
	TAX_EXEMPTION_TYPES_MAP,
	RECURRENCE_FREQUENCIES,
	FORM_JOB_TYPES,
	JURISDICTION_EXPIRES_OPTIONS,
	DAYS_OF_WEEK,
	JOB_POSTED_TYPES,
	OFFICER_STATUS_TO_FETCH_DATA,
	UN_ASSIGNMENT_REASONS,
	ORGANIZATION_TYPE,
	BULK_PAYMENT_JOB_TIMER,
	BULK_PAYMENT_STATUSES,
	AUTO_APPROVAL_TYPES,
	CALENDAR_DATE_FORMAT,
	OFFICER_VETTED_STATUS,
	LOCATION_DENIAL_UNASSIGN_ACTIONS,
	PAYMENT_METHOD_TYPES,
	BANK_ACCOUNT_TYPES,
	BANK_ACCOUNT_STATUSES,
	ORGANIZATION_SETTINGS_MENU,
	STATIC_URLS,
	JURISDICTION_FEE_TYPES,
	VIEW_INVOICE_STATUS,
	VIEW_INVOICE_STATUS_MAP,
	JOBS_ALERTS_LEGEND,
	OFFICERS_ACTIONGRID,
	INVOICE_FEE_TYPES,
	RECURRENCE_CONFLICT_TYPES,
	B2C_USER_CANCELLED,
	ROUTES,
	ADOPERATIONS,
};
